import { useEffect, useState } from "react";
import { UsersThree, Phone, Buildings } from "@phosphor-icons/react";
import { api } from "../lib/api";

export default function Tenants() {
  const [items, setItems] = useState([]);
  useEffect(() => { api.get("/api/tenants").then(({ data }) => setItems(data.items)).catch(() => {}); }, []);

  return (
    <div className="space-y-4 font-sans" data-testid="tenants-screen">
      <div>
        <p className="text-[11px] font-bold uppercase tracking-[0.32em] text-white/50">Registry</p>
        <h1 className="font-display text-3xl font-extrabold text-white">Tenants & Owners</h1>
      </div>

      {items.length === 0 ? (
        <div className="card flex flex-col items-center gap-2 p-10 text-center">
          <div className="flex h-12 w-12 items-center justify-center rounded-2xl bg-neon-cyan/15 text-neon-cyan"><UsersThree size={22} weight="duotone" /></div>
          <p className="font-display text-base font-semibold text-white">No residents yet</p>
          <p className="text-[13px] text-white/55">Once residents sign up via OTP they'll appear here.</p>
        </div>
      ) : (
        <div className="grid gap-3 md:grid-cols-2 xl:grid-cols-3">
          {items.map((u) => (
            <div key={u.id} className="card p-4" data-testid={`tenant-${u.id}`}>
              <div className="flex items-center gap-3">
                <div className="flex h-10 w-10 items-center justify-center rounded-2xl bg-gradient-to-br from-neon-cyan to-neon-lime font-display text-base font-extrabold text-black">{u.name[0]?.toUpperCase()}</div>
                <div className="min-w-0 flex-1">
                  <p className="truncate font-display text-[15px] font-semibold text-white">{u.name}</p>
                  <div className="mt-1 flex flex-wrap gap-1.5">
                    <span className="chip">{u.role}</span>
                    {u.flatId && <span className="chip"><Buildings size={11} weight="fill" className="mr-1" /> {u.flatId}</span>}
                    {u.phone && <span className="chip"><Phone size={11} weight="fill" className="mr-1" /> +91 {u.phone}</span>}
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
